var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.needsMherPlaceholder)?_c('div',{staticClass:"mher-container"},[_c('div',_vm._b({staticClass:"mher-wrapper",domProps:{"innerHTML":_vm._s(_setup.mherFragment)}},'div',_setup.dataAttributes,false))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }